import React from "react";
import SearchHomeFilter from "./search-home-filter";
import MainHeader from "../main/main-header";
import MainFooter from "../main/main-footer";
import SearchHomeBlock from "./search-home-block";
import './search-home.css';
import { useWindowWidth } from "@react-hook/window-size";

const features = [
    {
        title: "Модуль онлайн бронирования",
        description: "Виджет продажи путёвок для сайта и сообщества",
        img: "/images/icon-shield.svg",
    },
    {
        title: "Мгновенное подтверждение",
        description: "Расчёт стоимости и реальное наличие мест",
        img: "/images/icon-award.svg",
    },
    {
        title: "Онлайн оплата путёвок",
        description: "Комиссия за эквайринг от 1,5%",
        img: "/images/icon-clock.svg",
    },
];

const SearchHome = () => {
    const isMobile = useWindowWidth() <= 992;
    const bgimg = isMobile ? "url(\"/images/search-bgm.png\")" : "url(\"/images/search-bg.png\")";
    return (
        <div className="search-home-page">
            <MainHeader />
            <div className="search-home">
                <div className="search-home-hero" style={{ backgroundImage: bgimg }}>
                    <div className="search-home-hero-inner">
                        <h1 className="search-home-hero-title">Путешествуйте по России с нами</h1>
                        {!isMobile && <SearchHomeFilter />}
                    </div>
                </div>
                {isMobile && (
                    <div className="search-home-filter-wrap">
                        <SearchHomeFilter />
                    </div>
                )}
                <div className="search-home-features">
                    <div className="search-home-features-inner">
                        {features.map((item) => (
                            <SearchHomeBlock key={item.title} img={item.img} title={item.title} text={item.description} link="http://modul.rr-tour.ru" />
                        ))}
                    </div>
                </div>
            </div>
            <MainFooter hidden={false}/>
        </div>
    )
}

export default SearchHome;
